module.exports = __webpack_public_path__ + "assets/06c9a5a62a92d019d1e945ffd8755034.mp3";